import { Pipe, PipeTransform } from '@angular/core';
import readableFileSize from '../utils/readable-file-size';

@Pipe({
  name: 'readableFileSize'
})
export class FileSizePipe implements PipeTransform {
  transform(value) {
    if (!value) {
      return null;
    }
    return readableFileSize(value);
  }
}
